var map = {
	"./Casino.webp": 1747,
	"./Cricket.webp": 2292,
	"./Election.webp": 1748,
	"./Fantasy.webp": 1749,
	"./Finance-Trading.webp": 1246,
	"./Horse-Racing.webp": 1245,
	"./Inplay.webp": 2293,
	"./Live-Card.webp": 2294,
	"./Live-Cards.webp": 1750,
	"./Live-Casino.webp": 2295,
	"./Premium-Notebook.webp": 2296,
	"./Slot-game.webp": 1751,
	"./Soccer.webp": 2297,
	"./Sportsbook.webp": 2298,
	"./Tennis.webp": 2299,
	"./fantasybookicon.webp": 1752,
	"./fundlist.webp": 1753,
	"./greyhound.webp": 2300,
	"./horse.webp": 1149,
	"./more.webp": 2301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1598;